import React from 'react';
import './loading.styles.scss';
import LoadingImage from '../../assets/images/svg/loading_eclipse.svg';
import Backdrop from '../backdrop/backdrop.component';

interface IProps {
    className?: string;
}

function Loading({ className }: IProps) {
    return (
        <Backdrop show={true} className={className}>
            <img className="loading-image" src={LoadingImage} alt="loading" />
        </Backdrop>
    );
}

export default Loading;
